import * as React from "react";
const { useReducer } = React;

type StateType = {
    loading: boolean;
    loadingMessage: string;
    success: any;
    error: any;
    errorCode: any;
};

type ActionsType = {
    request: (message?: any) => void;
    success: (success?: any) => void;
    fail: (error?: any, errorCode?: any) => void;
};

const initialState: StateType = {
    loading: false,
    loadingMessage: "",
    success: "",
    error: "",
    errorCode: "",
};

const reducer = (state: StateType = initialState, action: any): StateType => {
    switch (action.type) {
        case "REQUEST":
            return {
                ...initialState,
                loading: true,
                loadingMessage: action.message,
            };
        case "SUCCESS":
            return {
                ...state,
                loading: false,
                loadingMessage: "",
                success: action.success,
                error: "",
                errorCode: "",
            };
        case "FAIL":
            return {
                ...state,
                loading: false,
                loadingMessage: "",
                success: "",
                error: action.error,
                errorCode: action.errorCode,
            };
        default:
            return state;
    }
};

const useAsyncState = (): [StateType, ActionsType] => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const actions: ActionsType = {
        request: (message: any): any => dispatch({ type: "REQUEST", message }),
        success: (success: any = true): any =>
            dispatch({ type: "SUCCESS", success }),
        fail: (error: any, errorCode: any): any =>
            dispatch({ type: "FAIL", error, errorCode }),
    };
    return [state, actions];
};

export default useAsyncState;
